import { Client } from "@microsoft/microsoft-graph-client";
import { config, getAccessToken } from "./AADHelper";

export interface AADUser {
    "@odata.context": string;
    businessPhones: [];
    displayName: string;
    givenName: string;
    id: string;
    jobTitle: string;
    mail: string;
    mobilePhone: string;
    officeLocation: string;
    preferredLanguage: string;
    surname: string;
    userPrincipalName: string;
}

export interface AuthState {
    error: any;
    isAuthenticated: boolean;
    user?: AADUser;
}

export const getUserProfile = async (): Promise<AuthState> => {
    try {
        var accessToken = await getAccessToken([config.scopes.user]);

        if (accessToken) {
            var user = await getUserDetails(accessToken);
            return {
                isAuthenticated: true,
                user: {
                    ...user
                },
                error: null
            };
        }
        clearSession();
        return {
            isAuthenticated: false,
            user: undefined,
            error: null
        }
    }
    catch (err:any) {
        clearSession();
        return {
            isAuthenticated: false,
            user: undefined,
            error: normalizeError(err)
        };
    }
}

function getAuthenticatedClient(accessToken: string) {
    const client = Client.init({
        authProvider: (done: any) => {
            done(null, accessToken);
        }
    });

    return client;
}

async function getUserDetails(accessToken: string) {
    const client = getAuthenticatedClient(accessToken);
    const user = await client
        .api('/me')
        .get();
    return user;
}

async function getUserPhoto(accessToken: string) {
    const client = getAuthenticatedClient(accessToken);
    var photo = await client
        .api('/me/photo/$value')
        .get();
    const url = URL.createObjectURL(photo);
    return url;
}

export const normalizeError = (error: string | Error): any => {
    var normalizedError = {};
    if (typeof (error) === 'string') {
        var errParts = error.split('|');
        normalizedError = errParts.length > 1 ?
            { message: errParts[1], debug: errParts[0] } :
            { message: error };
    } else {
        normalizedError = {
            message: error.message,
            debug: JSON.stringify(error)
        };
    }
    return normalizedError;
}

export const clearSession = () => {
    sessionStorage.clear();
    localStorage.clear();
}